/* eslint-disable camelcase */
import Accordion from "./Accordion";
import SidebarSlider from "./SidebarSlider";
import Notices from "./Notices";
import AjaxBlocking from "./AjaxBlocking";

export default class SidebarCart {
    constructor() {
        this.cartPage = document.querySelector("div.cart-page");
        this.isCartPage = !!this.cartPage;

        this.checkoutPage = document.querySelector("div.checkout__wrap");
        this.isCheckoutPage = !!this.checkoutPage;

        this.sidebar = document.querySelector(".cart-sidebar");
        this.cartBtn = document.querySelector(".jsHeaderTopIconCart");
        this.closeCartBtn = [
            ...document.querySelectorAll(".jsCartSidebarClose"),
        ];
        this.darkOverlay = document.querySelector(
            ".cart-sidebar__dark-overlay"
        );
        this.removeItem = document.getElementsByClassName(
            "js-remove_from_cart_button"
        );
        this.body = document.body;
        if (this.sidebar && this.cartBtn && this.closeCartBtn.length) {
            this.toggleSidebar();
        }
        this.cartAccordion = new Accordion("accordion-header");
        this.timeout = null;

        this.events();
        this.cartActions();
    }

    events() {
        window.addEventListener("DOMContentLoaded", (e) => {
            if (!this.isCartPage) {
                this.getCartCount();
            }
        });
    }

    toggleSidebar() {
        this.cartBtn.addEventListener("click", () => {
            this.getCartContent();
            this.sidebar.classList.add("open");
            this.body.style.overflow = "hidden";
            this.body.style.height = "100%";
            this.darkOverlay.classList.add("active");
        });

        this.closeCartBtn.forEach((btn) => {
            btn.addEventListener("click", () => {
                this.closeSidebar();
            });
        });

        this.darkOverlay.addEventListener("click", () => {
            this.closeSidebar();
        });
    }

    closeSidebar() {
        this.sidebar.classList.remove("open");
        this.body.style.overflow = "auto";
        this.body.style.height = "auto";
        this.darkOverlay.classList.remove("active");
    }

    cartActions() {
        this.removeFromCart();
        this.changeQuantityButtons();
        this.coupons();
        this.remove_coupon();
    }

    removeFromCart() {
        // eslint-disable-next-line no-unused-vars
        const self = this;
        this.removeItem = document.getElementsByClassName(
            "js-remove_from_cart_button"
        );
        [...this.removeItem].forEach((el) => {
            // eslint-disable-next-line no-unreachable
            el.addEventListener("click", function (e) {
                e.preventDefault();
                const key = e.currentTarget.dataset.cartItemKey;
                let url =
                    window.global.ajax_url +
                    "?action=RemoveCartItem&item_key=" +
                    key;
                if (self.isCartPage) url += "&cart_page=true";

                self.blockForAjax();

                fetch(url, {
                    method: "GET", //* GET, POST, PUT, DELETE, etc.
                    mode: "cors", // no-cors, *cors, same-origin
                    cache: "no-cache", //* default, no-cache, reload, force-cache, only-if-cached
                    credentials: "same-origin", // include, *same-origin, omit
                    headers: {
                        // "Content-Type": "application/json",
                        "Content-Type": "application/x-www-form-urlencoded",
                    },
                    redirect: "follow", // manual, *follow, error
                    referrerPolicy: "no-referrer", // no-referrer, *client
                })
                    .then((resp) => resp.json())
                    .then((data) => {
                        if (self.isCartPage) {
                            self.getCartPageContent();
                            // eslint-disable-next-line no-unused-vars
                            const cartNotices = new Notices(true);
                        } else {
                            self.getCartContent();
                        }
                    })
                    .catch((err) => {
                        console.log(err);
                        self.unblockForAjax();
                    });
            });
        });
    }

    changeQuantityButtons() {
        const self = this;

        function qty(elements) {
            [...elements].forEach((el) => {
                const quantity = el.querySelector(".quantity");

                if (!quantity) return;

                const plus_button = quantity.querySelector(".quantity-plus");
                const minus_button = quantity.querySelector(".quantity-minus");
                const qty = quantity.querySelector(".qty");

                let qty_value = parseInt(qty.value, 10);

                plus_button.addEventListener("click", () => {
                    qty_value = parseInt(qty.value, 10);
                    const maxVal = parseInt(qty.max, 10);

                    if (!maxVal || (maxVal && qty_value < maxVal)) {
                        qty.value = qty_value + 1;
                    } else {
                        qty.value = maxVal;
                        // return;
                    }

                    self.changeQtyTimeout(el, qty.value);
                });

                minus_button.addEventListener("click", () => {
                    qty_value = parseInt(qty.value, 10);
                    const minVal = parseInt(quantity.min, 10);

                    if (
                        (!minVal && qty_value > 1) ||
                        (minVal && minVal <= qty_value)
                    ) {
                        qty.value = qty_value - 1;
                    } else if (minVal && minVal > qty_value) {
                        qty.value = minVal;
                        return;
                    } else {
                        qty.value = qty_value;
                        return;
                    }

                    self.changeQtyTimeout(el, qty.value);
                });

                qty.addEventListener("keyup", () => {
                    let new_qty_value = parseInt(qty.value, 10);
                    const maxVal = parseInt(qty.max, 10);
                    // const minVal = parseInt(qty.min, 10);
                    const minVal = 1;

                    if (!new_qty_value && new_qty_value != 0) {
                        return;
                    }

                    if (new_qty_value === 0) {
                        new_qty_value = 1;
                    }

                    if (!maxVal || (maxVal && new_qty_value < maxVal)) {
                        qty.value = new_qty_value;
                    } else {
                        setTimeout(() => {
                            qty.value = maxVal;
                        }, 500);
                        self.changeQtyTimeout(el, new_qty_value);
                        return;
                    }

                    if (
                        (!minVal && new_qty_value >= 1) ||
                        (minVal && minVal <= new_qty_value)
                    ) {
                        qty.value = new_qty_value;
                    } else if (minVal && minVal > new_qty_value) {
                        qty.value = minVal;
                        return;
                    } else {
                        qty.value = new_qty_value;
                        return;
                    }

                    if (!isNaN(new_qty_value)) {
                        qty_value =
                            new_qty_value === 0 ? 1 : Math.abs(new_qty_value);
                        qty.value = qty_value;
                    } else {
                        qty.value = qty_value;
                        return;
                    }

                    self.changeQtyTimeout(el, new_qty_value);
                });
            });
        }

        const product_cart = document.getElementsByClassName(
            "cart-sidebar__product"
        );

        if (this.isCartPage) {
            const page_cart_items =
                document.getElementsByClassName("cart-page__product");

            qty(page_cart_items);
        }

        qty(product_cart);
    }

    changeQtyTimeout(element, qty) {
        const self = this;

        if (self.timeout !== undefined) {
            clearTimeout(self.timeout);
        }

        self.timeout = setTimeout(() => {
            self.changeQty(element, qty);
        }, 500);
    }

    changeQty(element, qty) {
        let parent = element.closest(".cart-sidebar__product");
        parent = parent || element.closest(".cart-page__product");
        const id = parent.dataset.productId;

        this.blockForAjax();

        fetch(window.global.ajax_url + "?action=ChangeItemQty", {
            method: "POST", //* GET, POST, PUT, DELETE, etc.
            mode: "cors", // no-cors, *cors, same-origin
            cache: "no-cache", //* default, no-cache, reload, force-cache, only-if-cached
            credentials: "same-origin", // include, *same-origin, omit
            headers: {
                // "Content-Type": "application/json",
                "Content-Type": "application/x-www-form-urlencoded",
            },
            redirect: "follow", // manual, *follow, error
            referrerPolicy: "no-referrer", // no-referrer, *client
            body: new URLSearchParams({
                security: window.global.security,
                id: id,
                qty: qty,
                isCartPage: this.isCartPage,
            }),
        })
            .then((resp) => resp.json())
            .then((data) => {
                if (data.success) {
                    this.changeCartView(data.data);
                } else {
                    if (
                        Object.prototype.hasOwnProperty.call(
                            data.data,
                            "wc_notices"
                        )
                    ) {
                        this.displayMiniCartStockNotice(data.data.wc_notices);
                    }
                    // eslint-disable-next-line no-unused-vars
                    const cartNotices = new Notices(true);
                }
            })
            .catch((err) => {
                console.log(err);
                this.unblockForAjax();
            });
    }

    coupons() {
        if (this.isCheckoutPage) {
            document.body.addEventListener("click", (e) => {
                if (e.target.classList.contains("couponSubmitJs")) {
                    e.preventDefault();
                    const code = document.querySelector(
                        ".cart-sidebar__discount-input"
                    ).value;
                    this.add_acoupon_to_cart(code);
                }
            });
        } else {
            const couponsEl = document.getElementById("js-mini-cart-coupon");
            if (couponsEl) {
                couponsEl.addEventListener("submit", (event) => {
                    event.preventDefault();
                    const code = event.target.querySelector(
                        ".cart-sidebar__discount-input"
                    ).value;
                    this.add_acoupon_to_cart(code);
                });
            }
        }
    }

    remove_coupon() {
        if (this.isCheckoutPage) {
            const couponsEl =
                document.getElementsByClassName("js-remove-coupon");

            document.body.addEventListener("click", (e) => {
                if (e.target.classList.contains("js-remove-coupon")) {
                    e.preventDefault();
                    this.blockForAjax();
                    const coupon_name = e.target.dataset.coupon;
                    fetch(window.global.ajax_url + "?action=RemoveCoupon", {
                        method: "POST", //* GET, POST, PUT, DELETE, etc.
                        mode: "cors", // no-cors, *cors, same-origin
                        cache: "no-cache", //* default, no-cache, reload, force-cache, only-if-cached
                        credentials: "same-origin", // include, *same-origin, omit
                        headers: {
                            // "Content-Type": "application/json",
                            "Content-Type": "application/x-www-form-urlencoded",
                        },
                        redirect: "follow", // manual, *follow, error
                        referrerPolicy: "no-referrer", // no-referrer, *client
                        body: new URLSearchParams({
                            security: window.global.security,
                            code: coupon_name,
                            isCartPage: this.isCartPage,
                            isCheckoutPage: this.isCheckoutPage,
                        }),
                    })
                        .then((resp) => resp.json())
                        .then((data) => {
                            console.log(data);
                            if (data.success) {
                                if (this.isCheckoutPage) {
                                    jQuery("body").trigger("update_checkout");

                                    document.querySelector(
                                        ".checkout__review__content"
                                    ).innerHTML = data.data.checkout_content;

                                    if (
                                        Object.prototype.hasOwnProperty.call(
                                            data.data,
                                            "wc_notices"
                                        )
                                    ) {
                                        this.displayMiniCartCouponNotice(
                                            data.data.wc_notices
                                        );
                                    }

                                    this.scrollTopOnChange(true);
                                    this.unblockForAjax();
                                } else {
                                    this.changeCartView(data.data);
                                    this.scrollTopOnChange(true);
                                }
                            } else {
                                if (
                                    Object.prototype.hasOwnProperty.call(
                                        data.data,
                                        "wc_notices"
                                    )
                                ) {
                                    this.displayMiniCartCouponNotice(
                                        data.data.wc_notices
                                    );
                                }
                                // eslint-disable-next-line no-unused-vars
                                const cartNotices = new Notices(true);
                                this.unblockForAjax();
                                this.scrollTopOnChange(true);
                            }
                        })
                        .catch((err) => {
                            console.log(err);
                            this.unblockForAjax();
                        });
                }
            });
        } else {
            const couponsEl =
                document.getElementsByClassName("js-remove-coupon");

            if (couponsEl) {
                [...couponsEl].forEach((el) => {
                    el.addEventListener("click", (event) => {
                        event.preventDefault();
                        this.blockForAjax();
                        const coupon_name = el.dataset.coupon;
                        fetch(window.global.ajax_url + "?action=RemoveCoupon", {
                            method: "POST", //* GET, POST, PUT, DELETE, etc.
                            mode: "cors", // no-cors, *cors, same-origin
                            cache: "no-cache", //* default, no-cache, reload, force-cache, only-if-cached
                            credentials: "same-origin", // include, *same-origin, omit
                            headers: {
                                // "Content-Type": "application/json",
                                "Content-Type":
                                    "application/x-www-form-urlencoded",
                            },
                            redirect: "follow", // manual, *follow, error
                            referrerPolicy: "no-referrer", // no-referrer, *client
                            body: new URLSearchParams({
                                security: window.global.security,
                                code: coupon_name,
                                isCartPage: this.isCartPage,
                            }),
                        })
                            .then((resp) => resp.json())
                            .then((data) => {
                                if (data.success) {
                                    if (this.isCheckoutPage) {
                                        jQuery("body").trigger(
                                            "update_checkout"
                                        );

                                        document.querySelector(
                                            ".checkout__review__content"
                                        ).innerHTML =
                                            data.data.checkout_content;

                                        if (
                                            Object.prototype.hasOwnProperty.call(
                                                data.data,
                                                "wc_notices"
                                            )
                                        ) {
                                            this.displayMiniCartCouponNotice(
                                                data.data.wc_notices
                                            );
                                        }

                                        this.scrollTopOnChange(true);
                                        this.unblockForAjax();
                                    } else {
                                        this.changeCartView(data.data);
                                        this.scrollTopOnChange(true);
                                    }
                                } else {
                                    if (
                                        Object.prototype.hasOwnProperty.call(
                                            data.data,
                                            "wc_notices"
                                        )
                                    ) {
                                        this.displayMiniCartCouponNotice(
                                            data.data.wc_notices
                                        );
                                    }
                                    // eslint-disable-next-line no-unused-vars
                                    const cartNotices = new Notices(true);
                                    this.unblockForAjax();
                                    this.scrollTopOnChange(true);
                                }
                            })
                            .catch((err) => {
                                console.log(err);
                                this.unblockForAjax();
                            });
                    });
                });
            }
        }
    }

    add_acoupon_to_cart(code) {
        this.blockForAjax();

        fetch(window.global.ajax_url + "?action=ApplyCoupon", {
            method: "POST", //* GET, POST, PUT, DELETE, etc.
            mode: "cors", // no-cors, *cors, same-origin
            cache: "no-cache", //* default, no-cache, reload, force-cache, only-if-cached
            credentials: "same-origin", // include, *same-origin, omit
            headers: {
                // "Content-Type": "application/json",
                "Content-Type": "application/x-www-form-urlencoded",
            },
            redirect: "follow", // manual, *follow, error
            referrerPolicy: "no-referrer", // no-referrer, *client
            body: new URLSearchParams({
                security: window.global.security,
                code: code,
                isCartPage: this.isCartPage,
                isCheckoutPage: this.isCheckoutPage,
            }),
        })
            .then((resp) => resp.json())
            .then((data) => {
                if (data.success) {
                    if (this.isCheckoutPage) {
                        jQuery("body").trigger("update_checkout");

                        if (
                            Object.prototype.hasOwnProperty.call(
                                data.data,
                                "wc_notices"
                            )
                        ) {
                            this.displayMiniCartCouponNotice(
                                data.data.wc_notices
                            );
                        }

                        document.querySelector(
                            ".checkout__review__content"
                        ).innerHTML = data.data.checkout_content;

                        this.unblockForAjax();
                    } else {
                        this.changeCartView(data.data);
                        this.scrollTopOnChange(true);
                    }
                } else {
                    if (
                        Object.prototype.hasOwnProperty.call(
                            data.data,
                            "wc_notices"
                        )
                    ) {
                        this.displayMiniCartCouponNotice(data.data.wc_notices);
                    }
                    // eslint-disable-next-line no-unused-vars
                    if (this.isCartPage) {
                        const cartNotices = new Notices(true);
                    }

                    this.unblockForAjax();
                    this.scrollTopOnChange(true);
                }
            })
            .catch((err) => {
                console.log(err);
                this.unblockForAjax();
            });
    }

    getCartCount() {
        fetch(window.global.ajax_url + "?action=getCartCount", {
            method: "GET", //* GET, POST, PUT, DELETE, etc.
            mode: "cors", // no-cors, *cors, same-origin
            cache: "no-cache", //* default, no-cache, reload, force-cache, only-if-cached
            credentials: "same-origin", // include, *same-origin, omit
            headers: {
                // "Content-Type": "application/json",
                "Content-Type": "application/x-www-form-urlencoded",
            },
            redirect: "follow", // manual, *follow, error
            referrerPolicy: "no-referrer", // no-referrer, *client
        })
            .then((resp) => resp.json())
            .then((data) => {
                if (data.success) {
                    document.getElementById("header-cart-count").innerHTML =
                        data.data.count;
                }
            })
            .catch((err) => {
                console.log(err);
                this.unblockForAjax();
            });
    }

    getCartPageContent() {
        this.blockForAjax();

        fetch(window.global.ajax_url + "?action=GetCartContent", {
            method: "GET", //* GET, POST, PUT, DELETE, etc.
            mode: "cors", // no-cors, *cors, same-origin
            cache: "no-cache", //* default, no-cache, reload, force-cache, only-if-cached
            credentials: "same-origin", // include, *same-origin, omit
            headers: {
                // "Content-Type": "application/json",
                "Content-Type": "application/x-www-form-urlencoded",
            },
            redirect: "follow", // manual, *follow, error
            referrerPolicy: "no-referrer", // no-referrer, *client
        })
            .then((resp) => resp.json())
            .then((data) => {
                if (data.success) {
                    console.log(data);
                    this.changeCartView(data.data);
                }
            })
            .catch((err) => {
                console.log(err);
                this.unblockForAjax();
            });
    }

    getCartContent() {
        this.blockForAjax();

        fetch(window.global.ajax_url + "?action=GetMiniCartContent", {
            method: "GET", //* GET, POST, PUT, DELETE, etc.
            mode: "cors", // no-cors, *cors, same-origin
            cache: "no-cache", //* default, no-cache, reload, force-cache, only-if-cached
            credentials: "same-origin", // include, *same-origin, omit
            headers: {
                // "Content-Type": "application/json",
                "Content-Type": "application/x-www-form-urlencoded",
            },
            redirect: "follow", // manual, *follow, error
            referrerPolicy: "no-referrer", // no-referrer, *client
        })
            .then((resp) => resp.json())
            .then((data) => {
                if (data.success) {
                    this.changeCartView(data.data);
                }
            })
            .catch((err) => {
                console.log(err);
                // this.unblockForAjax();
            });
    }

    openCart(message) {
        this.sidebar.classList.add("open");
        this.body.style.overflow = "hidden";
        this.body.style.height = "100%";
        this.darkOverlay.classList.add("active");

        this.displayMiniCartAddedToCart(message);
        // eslint-disable-next-line no-unused-vars
        const cartNotices = new Notices(true);
    }

    changeCartView(data, isAddToCart = false) {
        const cartSidebarEl = document.getElementsByClassName("cart-sidebar");
        const cartCountEl = document.getElementById("mini-cart-count");
        const headerCartCount = document.getElementById("header-cart-count");
        const cartTotal = document.getElementById("mini-cart-total");
        const cartSubtitle = document.getElementById("mini-cart-subtitle-info");

        if (data.cart_content) {
            [...cartSidebarEl].forEach((el) => {
                el.querySelector(".cart-sidebar__content").innerHTML =
                    data.cart_content;
            });
        }

        if (data.is_empty) {
            const cartPage = document.querySelector(".cart-page");
            if (cartPage) {
                cartPage.innerHTML = data.cart_empty;
            }
        } else if (this.isCheckoutPage) {
            console.log(data.cart_page_content);
        } else {
            if (data.cart_page_content) {
                const pageCartContent =
                    document.getElementById("page-cart-items");
                if (pageCartContent) {
                    pageCartContent.innerHTML = data.cart_page_content;
                }
            }

            if (data.cart_summary) {
                const pageCartSummary =
                    document.getElementById("page-cart-summary");

                if (pageCartSummary) {
                    pageCartSummary.innerHTML = data.cart_summary;
                }
            }

            if (data.gifts) {
                const pageCartGifts =
                    document.getElementById("page-cart-gifts");

                if (pageCartGifts) {
                    pageCartGifts.innerHTML = data.gifts;
                }
            }
        }

        if (Number.isInteger(data.cart_count)) {
            if (cartCountEl !== null) cartCountEl.innerHTML = data.cart_count;
            if (headerCartCount !== null)
                headerCartCount.innerHTML = data.cart_count;
        }

        if (Number.isInteger(data.cart_total) && cartTotal !== null) {
            cartTotal.innerHTML = data.cart_total;
        }

        if (data.shipping_info && cartSubtitle !== null) {
            cartSubtitle.innerHTML = data.shipping_info;
        }

        // eslint-disable-next-line no-use-before-define,no-unused-vars
        const sidebarSlider = new SidebarSlider();

        if (Object.prototype.hasOwnProperty.call(data, "wc_notices")) {
            if (data.type === "discount") {
                this.displayMiniCartCouponNotice(data.wc_notices);
            } else if (data.type === "stock") {
                this.displayMiniCartStockNotice(data.wc_notices);
            } else if (data.type === "addCart") {
                this.displayMiniCartAddedToCart(data.wc_notices);
            }
        }

        if (isAddToCart !== true) {
            // eslint-disable-next-line no-use-before-define,no-unused-vars
            const cartNotices = new Notices(true);
        }
        this.cartActions();
        this.unblockForAjax();
    }

    getSectionsForAjax() {
        let cartSections = [];

        if (this.isCartPage) {
            const pageCartContent = document.getElementById("page-cart-items");
            const pageCartSummary =
                document.getElementById("page-cart-summary");
            const pageCartGifts = document.getElementById("page-cart-gifts");

            if (pageCartContent) cartSections.push(pageCartContent);
            if (pageCartSummary) cartSections.push(pageCartSummary);
            if (pageCartGifts) cartSections.push(pageCartGifts);
        } else {
            const cartSidebarEl = [
                ...document.getElementsByClassName("cart-sidebar__body"),
            ];
            const countSidebarEl = document.querySelector(
                ".header-top__cart--count"
            );

            if (cartSidebarEl.length) {
                cartSections = [...cartSidebarEl];
            }
            if (countSidebarEl) {
                cartSections.push(countSidebarEl);
            }
        }

        if (this.isCheckoutPage) {
            const couponWrapper = document.getElementById(
                "js-mini-cart-coupon"
            );

            if (couponWrapper) cartSections.push(couponWrapper);

            const pageChcekoutContent = document.querySelector(
                ".checkout__review__content"
            );
            if (pageChcekoutContent) cartSections.push(pageChcekoutContent);

            const pageDiscount = document.querySelector(".cart-discount");
            if (pageDiscount) cartSections.push(pageDiscount);
        }

        return cartSections;
    }

    displayMiniCartAddedToCart(message) {
        const miniCartStockNotices = document.querySelector(
            ".jsCartSidebarStockNotices"
        );
        const addedCartNotices = document.querySelector(".jsPageNoticeWrapper");
        const noticesWrapper = document.getElementById("page__notices-wrapper");

        const widthWindow =
            window.innerWidth ||
            document.documentElement.clientWidth ||
            document.body.clientWidth;

        if (
            (widthWindow < 1280 && miniCartStockNotices !== null) ||
            (widthWindow > 1279 && addedCartNotices !== null)
        ) {
            if (widthWindow < 1280) {
                miniCartStockNotices.innerHTML = message;
            } else {
                noticesWrapper.innerHTML = message;
                addedCartNotices.classList.remove("is-hidden");

                window.setTimeout(() => {
                    addedCartNotices.classList.add("is-hidden");
                }, 6000);
            }
        }

        this.scrollTopOnChange();
    }

    displayMiniCartStockNotice(message) {
        const miniCartStockNotices = document.querySelector(
            ".jsCartSidebarStockNotices"
        );
        if (miniCartStockNotices) {
            miniCartStockNotices.innerHTML = message;
        }

        this.scrollTopOnChange();
    }

    displayMiniCartCouponNotice(message) {
        if (this.isCartPage) return;

        const miniCartNotices = document.querySelector(
            ".jsCartSidebarDiscountNotices"
        );
        if (miniCartNotices) {
            miniCartNotices.innerHTML = message;
        }
        this.scrollTopOnChange(true);
    }

    blockForAjax() {
        const sections = this.getSectionsForAjax();

        if (!sections.length) return;

        sections.forEach((section) => {
            const myBlock = new AjaxBlocking();
            myBlock.blockOnAjax(section);
        });
    }

    unblockForAjax() {
        const sections = this.getSectionsForAjax();

        if (!sections.length) return;

        sections.forEach((section) => {
            const myBlock = new AjaxBlocking();
            myBlock.unblockOnAjax(section);
        });
    }

    scrollTopOnChange(scrollToCoupons = false) {
        const anchor = document.querySelector(".jsCartSidebarStockNotices");
        const coupons = document.querySelector(".jsCartSidebarDiscountNotices");
        const cart_sidebar = document.querySelector(".cart-sidebar");

        if (this.isCheckoutPage) {
            window.setTimeout(() => {
                window.scrollTo({
                    top: 0,
                    behavior: "smooth",
                });
            }, 500);
            return;
        }

        if (coupons && scrollToCoupons === true) {
            coupons.scrollIntoView({
                behavior: "smooth",
            });
        }

        if (anchor && scrollToCoupons === false) {
            window.setTimeout(() => {
                cart_sidebar.scrollTo({
                    top: 0,
                    behavior: "smooth",
                });
            }, 500);
        }

        if (!this.isCartPage) return;

        window.setTimeout(() => {
            window.scrollTo({
                top: 0,
                behavior: "smooth",
            });
        }, 500);
    }
}
